import { Model } from "@vuex-orm/core";
import config from "../configs/MeetingCorrespondenceVote";

import Mandate from "./Mandate";
import Meeting from "./Meeting";

export default class MeetingCorrespondenceVote extends Model {
  static get entity() {
    return "meeting_correspondence_vote";
  }

  static fields() {
    return {
      id: this.attr(null),
      created: this.attr(null),
      updated: this.attr(null),
      deleted: this.attr(null),
      mandate_id: this.attr(null),
      meeting_id: this.attr(null),
      mandate: this.belongsTo(Mandate, "mandate_id"),
      meeting: this.belongsTo(Meeting, "meeting_id"),
      proposed_votes: this.attr(null),
      agency_id: this.attr(null),
    };
  }
  static get apiConfig() {
    return config;
  }
}
